export const PresetColors = ['blue', 'purple', 'cyan', 'green', 'magenta', 'pink', 'red', 'orange', 'yellow', 'volcano', 'geekblue', 'lime', 'gold'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/interface/presetColors.js
// module id = 1410
// module chunks = 0